import React, { FC, Suspense } from 'react'
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom'
import { PageLoader } from 'uiComponents/loaders'
import { BaseRouteParams } from 'hocs'
import AccountRoutes from './account'
import UserRoutes from './user'

const SettingsRoutes: FC<RouteComponentProps<BaseRouteParams>> = ({ match }) => {
    return (
        <Suspense fallback={<PageLoader />}>
            <Switch>
                <Route path="/account/:accountSlug/settings/account_settings" component={AccountRoutes} />
                <Route path="/account/:accountSlug/settings/users" component={UserRoutes} />
                <Redirect to={`/account/${match.params.accountSlug}/settings/account_settings`} />
            </Switch>
        </Suspense>
    )
}

export default SettingsRoutes
